export const SUPPORT_URL = 'https://servicedesk.oakland.k12.mi.us/servicedesk/customer/portal/19/user/login?destination=portal%2F19%2Fcreate%2F611'
